<template>
  <v-container class="main-container responsive-height">
    <v-row dense>
      <v-col cols="12" xl="12">
        <CloseTradeTabs></CloseTradeTabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CloseTradeTabs from "@/components/PagesComponents/CloseTradePage/CloseTradeTabs.vue";
export default {
  components: {
    CloseTradeTabs,
  },
};
</script>
